module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [(_vm.isFile) ? [_c('lxm-row', {
    attrs: {
      "icon-class": _vm.iconClass(_vm.row),
      "icon-mobile-class": _vm.iconMobileClass(_vm.row),
      "mobile-check": _vm.mobileCheck(_vm.row),
      "name": _vm.row.name,
      "value-site": 'left'
    }
  }, [_vm._l((_vm.row.files), function(item) {
    return [(item.value && item.valueLink) ? [_c('p', [_c('a', {
      attrs: {
        "target": "_blank",
        "href": item.valueLink
      }
    }, [_vm._v("\n              " + _vm._s(item.value) + "\n            ")])])] : _vm._e(), _vm._v(" "), (item.image) ? [_c('div', {
      staticClass: "lxm-row__content content"
    }, [_c('p', [_c('img', {
      staticClass: "lxm-row__content-image",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": item.image
      }
    })])])] : _vm._e()]
  })], 2)] : [_c('lxm-row', {
    attrs: {
      "icon-class": _vm.iconClass(_vm.row),
      "icon-mobile-class": _vm.iconMobileClass(_vm.row),
      "mobile-check": _vm.mobileCheck(_vm.row),
      "name": _vm.row.name,
      "image": _vm.row.image
    }
  }, [(_vm.row.value) ? [(_vm.row.type === 'tel') ? [_c('a', {
    attrs: {
      "href": ("tel:" + (_vm.row.value))
    }
  }, [_vm._v("\n            " + _vm._s(_vm.row.value) + "\n          ")])] : (_vm.row.valueLink) ? [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.row.valueLink
    }
  }, [_vm._v("\n            " + _vm._s(_vm.row.value) + "\n          ")])] : (_vm.row.type === 'note_array') ? [(_vm.row.value.length > 0) ? _c('div', _vm._l((_vm.row.value), function(item) {
    return _c('div', [_vm._v("\n              " + _vm._s(item) + "\n            ")])
  })) : _c('div', [_vm._v("无")]), _vm._v(" "), (_vm.row.is_show_more === 1) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.record_notes_more(_vm.row.current_num)
      }
    }
  }, [_vm._v("查看更多")]) : _vm._e()] : [_vm._v("\n          " + _vm._s(_vm.row.value) + "\n        ")]] : _vm._e(), _vm._v(" "), (_vm.row.content) ? _c('template', {
    slot: "content"
  }, [_vm._v("\n        " + _vm._s(_vm.row.content) + "\n      ")]) : _vm._e()], 2)]], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-113dcc05", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-113dcc05!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/common/LxmFormRow.vue
// module id = 819
// module chunks = 0